export const ENetworkQuality = {
  EXCELLENT: 'excellent',
  GOOD: 'good',
  OK: 'ok',
  BAD: 'bad',
};
